
<template>

    <div
        id="loadalert"
        class="downloadedFiles fixed bg-white shadow-lg outline-0 z-20 justify-center items-center w-87 right-16 bottom-56 text-sm leading-4"
        v-if="$store.state.downloaded.data.length || $store.state.downloaded.compressingZip.total"
    >
        <div class="flex border-b border-black bg-green-xcaret w-full p-3">
            <!-- <div class="flex-1" v-if="$store.state.downloaded.progress != null">{{ $t("download.dowloading") }} ({{ $store.state.downloaded.progress }} %)</div> -->
            <template v-if="$store.state.zip.total && $store.state.zip.compressed">
                <div
                class="flex-1 header text-white font-semibold"
                v-if="$store.state.downloaded.progressing && $store.state.downloaded.compressingZip.total > 0"
                >
                    {{  $t("download.zipping") }} {{ $store.state.downloaded.compressingZip.compressed }}
                    {{ $t("download.of") }} {{ $store.state.downloaded.compressingZip.total }}

                </div>
                <div
                    class="flex-1 header text-white font-semibold"
                    v-if="$store.state.zip.compressed === $store.state.zip.total && $store.state.downloaded.compressingZip.total === 0"
                >
                    {{$tc('download.zipping_complete', $store.state.zip.compressed)}}
                </div>
            </template>
           
            <div
                class="cursor-pointer close flex-1 text-right"
                @click.prevent="$store.dispatch('setDownloadsBoxStatus', !$store.state.componentes.displayDownloadBox)"
            >
                <span class="material-icons text-white font-semibold">
                    {{ $store.state.componentes.displayDownloadBox ? 'expand_less' : 'close' }}
                </span>
            </div>
        </div>
        <div
            class="mt-2 p-3 body"
            :class="$store.state.componentes.displayDownloadBox && 'hidden'"
        >
            <div
                class="item flex flex-wrap items-center justify-center"
                v-for="(item, idx) in $store.state.zip.data"
                :key="idx + item.name"
            >
                <span class="flex-auto flex items-center">
                    <span class="icon text-greendark-xcaret material-icons">
                        folder_zip
                    </span>
                    {{ item.name }}
                </span>
                <span class="flex-auto">&nbsp;</span>
                <span class="flex-1">
                    {{ $t("download.zipping") }}({{ item.porcent }}%)
                </span>
            </div>

            <div
                class="item flex flex-wrap items-center justify-center border rounded p-3 mb-2"
                v-for="(item, idx) in $store.state.downloaded.data"
                :key="idx"
            >
                <span class="flex-auto flex items-center">
                    <span class="icon text-greendark-xcaret material-icons">
                        file_download
                    </span>
                    {{ item.name }}
                </span>

                <span
                    class="flex-auto flex items-center"
                    v-if="item.mimeType.type == 2"
                >
                    <span v-if="item.state == 3">
                        <i v-if="$store.state.downloaded.compressingZip.compressed < $store.state.downloaded.compressingZip.total">{{ $t("download.qn_start") }}</i>
                        <i v-if="$store.state.downloaded.compressingZip.compressed === $store.state.downloaded.compressingZip.total">{{ $t("download.again") }}</i>
                        <a
                            :href="item.url"
                            download
                            class="cursor-pointer underline font-bold text-link-blue mr-2"
                        >
                            {{ $t("download.click") }}
                        </a>
                    </span>
                    <a
                        class="rounded pl-4 pr-4 pt-1 pb-1 cursor-pointer mr-2"
                        v-else-if="item.state == 2"
                    >
                        <span class="pointer-events-none">
                            {{ $t("download.dowloading") }}
                            <span class="material-icons"> downloading </span>
                        </span>
                    </a>
                    <a
                        class="rounded pl-4 pr-4 pt-1 pb-1 cursor-pointer mr-2"
                        v-else-if="item.state == 1"
                    >
                        <span class="pointer-events-none">
                            {{ $t("download.compressing") }}
                            <!-- <span class="material-icons"> compress </span> -->
                        </span>
                    </a>
                    <a
                        class="rounded pl-4 pr-4 pt-1 pb-1 cursor-pointer mr-2"
                        v-else
                    >
                        <span class="pointer-events-none">
                            {{ $t("download.pending") }}
                            <span class="material-icons">
                                <!-- animate-spin -->
                                pending
                            </span>
                        </span>
                    </a>
                    <!-- {{ item.porcent }}% -->
                </span>
                <span class="flex-1" v-else>
                    <i class="text-red font-semibold" v-if="item.state == 5">Error</i>
                    <template v-else>
                        {{ $t("download.finished") }}
                    </template>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import MultimediaMix from "../mixins/Multimedia";

export default {
    mixins: [MultimediaMix],
    methods: {
        downloadFile(url, name) {
            axios
                .get(url, { responseType: "blob" })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "application/zip",
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = name;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(() => {});
        },
    },
    computed: {},
    created() {},
    mounted() {},
};
</script>
